
document.addEventListener("DOMContentLoaded", function(event) {
    ((doc)=>{
        let myDoc = doc;

        Fancybox.bind('[data-fancybox="gallery"]');
        Fancybox.bind('[data-fancybox="galleryDom"]');
        Fancybox.bind('[data-fancybox="intorVideo"]', {
            Carousel: {
            Thumbs: false,
            },
        });

        let splideReview = myDoc.querySelector('.splideReview');
        if(splideReview){
            var reviewSplide = new Splide( splideReview, {
                gap        : 8,
                arrows     : false,
                pagination : false,
                mediaQuery  : 'min',
                destroy: false,
                padding: '1rem',
                focus  : 'center',
                breakpoints: {
                    768: {
                        perPage: 2,
                    },
                    992: {
                        destroy: true,
                    }
                }
            });
            reviewSplide.mount();
        };

        let youmaulike = myDoc.querySelectorAll('.homeStaffSlide');
        if(youmaulike){
            Object.keys(youmaulike).forEach((ele)=>{
                var staffSplide = new Splide( youmaulike[ele], {
                    gap: 6,
                    arrows : false,
                    pagination: false,
                    fixedWidth  : 170,
                    focus  : 'center',
                    mediaQuery: 'min',
                    padding: '1rem',
                    breakpoints: {
                        768: {
                            gap: 10,
                            omitEnd: true,
                            focus : 0,
                            fixedWidth  : 210,
                        }
                    }
                });
                staffSplide.mount();
            })
        }

        let duoWidth = myDoc.querySelector('.duoWithStaffSlide');
        if(duoWidth){
            var staffSplide = new Splide( duoWidth, {
                gap: 6,
                arrows : false,
                pagination: false,
                mediaQuery: 'min',
                focus  : 'center',
                padding: '1rem',
                classes: {
                    pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                    page      : 'splide__pagination--page border-0 rounded-circle mx-1',
                },
                breakpoints: {
                    576: {
                        fixedWidth  : '370px',
                        focus  : 0,
                    },
                    768: {
                        gap: 8,
                        omitEnd: true,
                    }
                }
            });
            staffSplide.mount();
        }


        function initSwiper() {
            const cardSwiper = new Swiper(".swipper-gallerySingle", {
                effect: "cards",
                grabCursor: true,
                observer: true,
                observeParents: true,
                resistanceRatio: 0,
                touchEventsTarget: 'container',
                breakpoints: {
                    768: {
                        spaceBetween: 20
                    },
                    1024: {
                        spaceBetween: 30
                    }
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous card',
                    nextSlideMessage: 'Next card'
                }
            });
            console.log(cardSwiper);
            return cardSwiper;
        }

        const cursor = document.querySelectorAll('.custom-cursor');
        const parent = document.body; // or a specific container

        parent.addEventListener('mousemove', (e) => {
            if (e.target.closest('.swipper-gallerySingle')) {
                cursor.forEach(c => {
                    c.style.display = 'block';
                    c.style.top = `${e.clientY}px`;
                    c.style.left = `${e.clientX}px`;
                });
            } else {
                cursor.forEach(c => c.style.display = 'none');
            }
        });



        let mySwiper = initSwiper();
        const tabEls = document.querySelectorAll('button[data-bs-toggle="tab"]');
        tabEls.forEach(tab => {
            tab.addEventListener('shown.bs.tab', function() {
                mySwiper.update();
                setTimeout(() => mySwiper.update(), 100);
            });
        });



        ((selector) => {
        const voiceNote = myDoc.querySelectorAll(selector);
            if(voiceNote){
                Object.keys(voiceNote).forEach((key) => {
                const playBtn = voiceNote[key].querySelector('.btn-playpause');
                const soundWave = playBtn.querySelector('.fa-waveform');
                const voice = voiceNote[key].querySelector('audio');
                playBtn.addEventListener('click', function() {
                    if (voice.paused) {
                    voice.play();
                        soundWave.classList.remove('d-none');
                    }else{
                    voice.pause();
                        soundWave.classList.add('d-none');
                    }
                });
                voice.addEventListener("ended", function() {
                    soundWave.classList.add('d-none');
                });
                });
                const stopOther = (e) => {
                    Object.keys(voiceNote).forEach((key) => {
                        if(voiceNote[key].querySelector('audio') != e.target){
                            voiceNote[key].querySelector('audio').pause();
                            voiceNote[key].querySelector('.btn-playpause .fa-waveform').classList.add('d-none');
                        }
                    });
                }
                Object.keys(voiceNote).forEach((key) => {
                    voiceNote[key].querySelector('audio').addEventListener('play', stopOther);
                });
            }
        })('.gallery-single-voicemail');


        let videos =  myDoc.querySelectorAll('.textareaVideo');
        if(videos){
            let videoContainer = myDoc.querySelector('.gallery-single-video .row'),
            videoTabBtn = myDoc.querySelector('#videos-tab'),
            VideoHtml='';
            videoContainer?videoContainer.innerHTML = '':null;
            Object.keys(videos).forEach(i=>{
                //console.log(videos[i].getAttribute('value'));
                VideoHtml += `
                <div class="col-md-6 mb-3">
                    <div class="media-holder video">
                        ${videos[i].getAttribute('value')}
                    </div>
                </div>
                `
            });
            if(VideoHtml && videoContainer !='') {
                videoTabBtn.addEventListener('click', ()=>{
                    videoContainer.innerHTML=VideoHtml;
                })
            }
        };

    })(document);
})


